export default {"src":"/_next/static/media/arts.7c2451c3.svg","height":77,"width":77,"blurWidth":0,"blurHeight":0};